import React from 'react'
import ESigningApiContent from '../components/ESigningApi/ESigningApiContent'

const ESigningApi = (props) => {

  

  return (
    <>
        <ESigningApiContent following = {props.following === true ? true : false}/>
    </>
  )
}

export default ESigningApi